import script from "./UiDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./UiDialog.vue?vue&type=script&setup=true&lang=js"

import "./UiDialog.vue?vue&type=style&index=0&id=67271292&lang=css"

const __exports__ = script;

export default __exports__